import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}
import Pdf from "../../../../../assets/pp/1PORTAFOLIO GENERAL ESTIMULOS PP CULTURA 28 abril 2025.pdf"

export const ModalVisualizarPortafolio: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{fontSize: '1.2em', textAlign: 'center' }}>
        <span className="pb-3 font-size-20px font-family-Montserrat-SemiBold">
            Portafolio de Estímulos 2025
        </span>
        <br />
        <iframe src={Pdf} style={{ width: '100%', height: '500px' }}></iframe>
      </div>
    </Modal>
  );
};
